import React from 'react';
import { Link } from 'react-router-dom';
import { useState } from "react";

const ContactMain = () => {
    // State for dynamic content
    const [whatsapp] = useState({
      title: "No te pierdas de nada! Únete a nuestra comunidad de WhatsApp",
      description:
        "¿Quieres estar al tanto de los eventos culturales, deportivos y de turismo más vibrantes? DJs, bailarines, músicos, profesores y experiencias únicas te esperan cada semana. Presiona en el botón o escanea el código QR para unirte a nuestro grupo de WhatsApp y no te pierdas ninguna actualización.",
      buttons: [
        { id: 1, text: "Enlace de WhatsApp", link: "https://chat.whatsapp.com/EwuN5XoUIGd9RR18PGxjjp", class: "buy-ticket__btn-1" }
      ],
    });

    return (
        <React.Fragment>
            {/*Contact One Start*/}
          <section className="contact-one">
            <div className="container">
              <div className="contact-one__inner">
                <h3 className="contact-one__title">Promociona con nosotros!</h3>
                <p className="contact-one__text">
                  Te ayudamos a difundir tus eventos culturales en Ecuador. Contáctanos
                  para más información.
                </p>
                <p className="contact-one__text">
                </p>
                <div className="result"></div>
              </div>
            </div>
          </section>
          {/*Contact One End*/}

          {/*Contact Two Start*/}
          <section className="contact-two">
            <div className="container">
              <div className="row">
                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-pin"></span>
                    </div>
                    <h3 className="contact-two__title">Dirección</h3>
                    <p className="contact-two__text">
                      Pichincha, Quito <br />
                      Tumbaco
                    </p>
                  </div>
                </div>
                {/* Contact Two Single End */}

                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-paper-plan"></span>
                    </div>
                    <h3 className="contact-two__title">Correo</h3>
                    <p className="contact-two__text">
                      <Link to="mailto:comercial@ecueventos000.com">
                        comercial@ecueventos000.com
                      </Link>
                    </p>
                    <p className="contact-two__text">
                      <br />
                    </p>
                  </div>
                </div>
                {/* Contact Two Single End */}

                {/* Contact Two Single Start */}
                <div className="col-xl-4 col-lg-4">
                  <div className="contact-two__single">
                    <div className="contact-two__icon">
                      <span className="icon-call"></span>
                    </div>
                    <h3 className="contact-two__title">Contacto</h3>
                    <p className="contact-two__text">
                      <a href="tel:(+593) 96 300 3755">(+593) 96 300 3755</a>,{" "}
                      <a href="tel:(+593) 98 310 7016">(+593) 98 310 7016</a>
                    </p>
                    <p className="contact-two__text">
                      
                    </p>
                  </div>
                </div>
                {/* Contact Two Single End */}
              </div>
            </div>
          </section>
          {/*Contact Two End*/}

          <section className="buy-ticket">
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div
                    className="buy-ticket__left wow fadeInLeft"
                    data-wow-delay="100ms"
                  >
                    <h3 className="buy-ticket__title">{whatsapp.title}</h3>
                    <p className="buy-ticket__text">{whatsapp.description}</p>
                    <div className="buy-ticket__btn-box">
                      {whatsapp.buttons.map((button) => (
                        <Link
                          key={button.id}
                          to={button.link}
                          className={`${button.class} thm-btn`}
                          target="_blank"
                        >
                          {button.text}
                          <span className="icon-arrow-right"></span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div
                    className="buy-ticket__right wow fadeInRight"
                    data-wow-delay="300ms"
                  >
                    <div className="buy-ticket__img">
                      <img src="https://storage.googleapis.com/ecueventos000-imgs/ecueventos000-whatsapp-qr.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
    );
};

export default ContactMain;
